import { render, staticRenderFns } from "./NotificacionPdfDialog.vue?vue&type=template&id=242ebc90"
import script from "./NotificacionPdfDialog.vue?vue&type=script&lang=js"
export * from "./NotificacionPdfDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports